<!-- Header -->
<div class="header text-align-center">
	<div><ngx-skeleton-loader [theme]="{ width: '200px', height: '40px' }"> </ngx-skeleton-loader></div>
	<div><ngx-skeleton-loader [theme]="{ width: '60%', height: '15px' }"> </ngx-skeleton-loader></div>
</div>

<!-- Search -->
<div class="margin-top-30 margin-left-10">
	<ngx-skeleton-loader [theme]="{ width: '200px', height: '30px' }"> </ngx-skeleton-loader>
</div>

<!-- Content -->
<div class="content grid">
	<div *ngFor="let row of GHOST_ROWS" class="row">
		<div class="col-16 padding-15">
			<ngx-skeleton-loader [theme]="{ width: '250px', height: '20px' }"> </ngx-skeleton-loader>
		</div>
		<div class="col-6 text-align-center padding-15">
			<ngx-skeleton-loader [theme]="{ width: '80px', height: '15px' }"> </ngx-skeleton-loader>
		</div>
		<div class="col-2 padding-horizontal-15 padding-top-20 padding-bottom-10">
			<ngx-skeleton-loader [theme]="{ width: '20px', height: '15px' }"> </ngx-skeleton-loader>
		</div>
	</div>
</div>
